import { Fragment } from "react";
import SearchOrCreateSelectInput from "../../core/inputs/SearchOrCreateSelectInput";
import { formatLocalTime } from "../../core/utils/utils";
import { getJobStatusOrSubStatusLabel } from "../utils/utils";


function getJobObjectLabel(job, preferredTimezone) {
    return <Fragment>
        <span><strong>{`${job.custom_id || job.id} (${getJobStatusOrSubStatusLabel(job)})`}</strong><br></br></span>
        <span className="select-label-secondary-level"><em>{`[${job.job_type}] ${job.service_name}`}</em><br></br></span>
        {job.start_time && <span className="select-label-secondary-level">{formatLocalTime(job.start_time, preferredTimezone, false, true, false, true).localDateTimeString}</span>}
    </Fragment>
}

function jobToJobOption(job, preferredTimezone) {
    return {value: job.id, label: getJobObjectLabel(job, preferredTimezone), object: job}
}

function JobSearchOrCreateSelect(props) {
    const {preferredTimezone} = props

    return <SearchOrCreateSelectInput
        objectName="Job"
        getObjectLabel={(job) => getJobObjectLabel(job, preferredTimezone)}
        listEndpoint={DjangoUrls["jobs:api-jobs-search"](window.MARKETPLACE_ENTITY_SLUG)}
        listEndpointKwargs={[
            ["ordering", "status,-start_time"],
        ]}
        getDetailsEndpoint={(job) => DjangoUrls["jobs:api-jobs-detail"](window.MARKETPLACE_ENTITY_SLUG, job.id)}
        {...props}
    />
}

export { jobToJobOption };
export default JobSearchOrCreateSelect
